export default __webpack_public_path__ + "43e1b67f1e7fad7051bdaa8c0bb379c0.webp";